<app-summary-card-template [chipNumber]="error.occurrenceCount" [loggableEntity]="error"
                           [occurredDate]="error.mostRecentOccurred">
</app-summary-card-template>
